import {UserAuthority} from './user-type.enum';

export class UserTypeGroup {
  static readonly CUSTOMER = [
    UserAuthority.CARC_ADMIN,
    UserAuthority.CARC_USER
  ] as const;

  static readonly INTERNAL = [
    UserAuthority.LIMITED,
    UserAuthority.STANDARD,
    UserAuthority.ADMIN
  ] as const;

  static isCustomerUser(userAuthorities: UserAuthority[]): boolean {
    return userAuthorities.some(auth => this.CUSTOMER.includes(auth as any));
  }

  static isInternalUser(userAuthorities: UserAuthority[]): boolean {
    return userAuthorities.some(auth => this.INTERNAL.includes(auth as any));
  }

  static getAllUserTypes(): UserAuthority[] {
    return [...this.CUSTOMER, ...this.INTERNAL];
  }
}
